export default __webpack_public_path__ + "static/east-main-video3-a738869657bad4e48ab99b753e8f47e3.jpg";